import React, { Component as C } from "react"
import styles from "./table-hint.less"
import classNames from "classnames"
import jss from "jss"
import withSkin from "@cirrus/legacy/app-common/alt/framework/withSkin.jsx"
import v from "@cirrus/legacy/app-components/app/styles/colors/colors-default.less"
import { toJss, darken } from "@cirrus/legacy/app-common/alt/framework/skin/skinUtils.es6"

class TableHint extends C {
  static dynamicStyles = null
  static displayName = "TableHint_EAs"

  constructor(props) {
    super(props)

    if (TableHint.dynamicStyles == null) {
      const dynamicStylesConfig = toJss((props.skinObject.table || {}).hint || {}, {
        tableHint: {
          color: v.gray420,
        },
      })

      TableHint.dynamicStyles = jss.createStyleSheet(dynamicStylesConfig).attach()
    }
  }

  render() {
    let { classes } = TableHint.dynamicStyles

    let extendLeft = null
    if (this.props.extendLeft != null) {
      extendLeft = `-${this.props.extendLeft}px`
    } else if (this.props.extend != null) {
      extendLeft = `-${this.props.extend}px`
    }

    let extendRight = null
    if (this.props.extendRight != null) {
      extendRight = `-${this.props.extendRight}px`
    } else if (this.props.extend != null) {
      extendRight = `-${this.props.extend}px`
    }

    return (
      <div
        className={classNames(
          styles.tableHint,
          classes.tableHint,
          { [styles.noLayout]: this.props.noLayout },
          this.props.className,
        )}
        style={{
          marginLeft: extendLeft,
          marginRight: extendRight,
        }}>
        {this.props.children}
      </div>
    )
  }
}

export default withSkin(TableHint)
